import { render, staticRenderFns } from "./importacao.vue?vue&type=template&id=7b03811a"
import script from "./importacao.vue?vue&type=script&lang=js"
export * from "./importacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports